<template>
    <div>
        <div>
            <div class="w-full pt-9 px-6">
                <div class="flex justify-between mb-4">
                    <div class="flex gap-x-3">
                        <div class="flex gap-x-4">
                            <input
                                type="date"
                                class="h-8 mr-2 rounded-md"
                                v-model="fromDate"
                                @change="dateChanged()"
                            />
                            <input
                                type="date"
                                class="h-8 mx-2 rounded-md"
                                v-model="toDate"
                                @change="dateChanged()"
                            />
                        </div>
                    </div>
                    <div class="flex gap-x-3">
                        <div
                            class="w-full !text-sm bg-white h-fit"
                            data-te-select-wrapper-ref
                        >
                            <select
                                data-te-select-init
                                data-te-select-placeholder="Select Area"
                                @change="areaChanged"
                                data-te-select-filter="true"
                                v-model="selectedArea"
                                class="input-ui"
                            >
                                <option
                                    :value="area"
                                    v-for="area in areaList"
                                    :key="area.id"
                                >
                                    {{ area.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="bg-white px-4">
                        <table class="min-w-full text-left text-sm font-light">
                            <thead
                                class="border-b font-medium bg-gray-50 text-gray-700"
                            >
                                <tr>
                                    <th scope="col" class="px-6 py-4 w-16">
                                        Id
                                    </th>
                                    <th scope="col" class="px-6 py-4">
                                        Selling Area
                                    </th>
                                    <th scope="col" class="px-6 py-4">
                                        Total Session Duration
                                    </th>
                                    <th scope="col" class="px-6 py-4">
                                        Total Session Price
                                    </th>
                                    <th scope="col" class="px-6 py-4">
                                        Total Service Charge
                                    </th>
                                    <th scope="col" class="px-6 py-4">
                                        Total Discount
                                    </th>
                                    <th scope="col" class="px-6 py-4">
                                        Total Tax
                                    </th>
                                    <th scope="col" class="px-6 py-4">
                                        Order Subtotal
                                    </th>
                                    <th scope="col" class="px-6 py-4">
                                        Subtotal
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(item, index) in primaryList"
                                    :key="index"
                                    class="border-b last:border-0 hover:bg-gray-50/50"
                                >
                                    <td
                                        class="whitespace-nowrap px-6 py-4 font-medium text-gray-900"
                                    >
                                        {{ index + 1 }}
                                    </td>

                                    <td class="whitespace-nowrap px-6 py-4">
                                        {{ item.area_name }}
                                    </td>

                                    <td class="whitespace-nowrap px-6 py-4">
                                        {{ item.total_session_duration }}
                                    </td>

                                    <td class="whitespace-nowrap px-6 py-4">
                                        {{ item.total_session_price }}
                                    </td>

                                    <td class="whitespace-nowrap px-6 py-4">
                                        {{ item.total_service_charge }}
                                    </td>

                                    <td class="whitespace-nowrap px-6 py-4">
                                        {{ item.total_discount_price }}
                                    </td>

                                    <td class="whitespace-nowrap px-6 py-4">
                                        {{ item.total_tax }}
                                    </td>

                                    <td class="whitespace-nowrap px-6 py-4">
                                        {{ item.order_sub_total_price }}
                                    </td>

                                    <td class="whitespace-nowrap px-6 py-4">
                                        {{ item.sub_total_price }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="flex justify-center">
                            <div
                                v-if="totalData != 0"
                                class="bg-white flex justify-center mt-5 py-3"
                            >
                                <button
                                    class="rounded px-6 py-1 border hover:bg-slate-200"
                                    :disabled="currentPage === 1"
                                    @click="getPrimaryList(currentPage - 1)"
                                >
                                    «
                                </button>
                                <button class="text-sm px-5 border">
                                    Page
                                    <span>{{ currentPage }}</span>
                                    /
                                    <span class="text-gray-400">{{
                                        lastPage
                                    }}</span>
                                </button>
                                <button
                                    class="rounded px-6 py-1 border hover:bg-slate-200"
                                    :disabled="currentPage === lastPage"
                                    @click="getPrimaryList(currentPage + 1)"
                                >
                                    »
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal, Ripple, Select, Datepicker, initTE } from "tw-elements";
import { getApiData } from "../../../utilities/ajax-helpers";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            primaryList: [],
            areaList: [],

            fromDate: null,
            toDate: null,
            selectedArea: null,

            total_amount: 0,

            currentPage: 0,
            perPage: 0,
            lastPage: 0,
            totalData: 0,

            url_date: "",
            url_area: "",
            url: "/api/pos/sale_invoice_report",
        };
    },

    methods: {
        ...mapGetters(["getToken"]),

        async getPrimaryList(pageNumber) {
            this.total_amount = 0;
            let url =
                this.url +
                "?page=" +
                pageNumber +
                this.url_date +
                this.url_area;
            const response = await getApiData({
                url: url,
                token: this.getToken(),
            });

            if (response && response.success && response.data) {
                const paginationData = response.data;

                if (paginationData.data) {
                    this.primaryList = paginationData.data;
                    this.primaryList.forEach((item) => {
                        // NOTE: Update 'grand_total' key to match your API response variable name
                        this.total_amount += Number(item.grand_total || 0);
                    });
                    this.currentPage = paginationData.current_page;
                    this.perPage = paginationData.per_page;
                    this.lastPage = paginationData.last_page;
                    this.totalData = paginationData.total;
                }
            }
        },

        dateChanged() {
            let dateParams = "";
            if (this.fromDate) {
                dateParams += "&from_date=" + this.fromDate;
            }
            if (this.toDate) {
                dateParams += "&to_date=" + this.toDate;
            }
            this.url_date = dateParams;
            this.getPrimaryList(1);
        },

        areaChanged() {
            if (this.selectedArea && this.selectedArea.id) {
                this.url_area = "&area_id=" + this.selectedArea.id;
            } else {
                this.url_area = "";
            }
            this.getPrimaryList(1);
        },

        async getAreaList() {
            let url = `/api/sellings_areas`;
            let response = await getApiData({
                url: url,
                token: this.getToken(),
            });
            if (response && response.data) {
                this.areaList = response.data;
            }
        },
    },

    mounted() {
        initTE({ Modal, Select, Ripple, Datepicker });
    },

    created() {
        this.getPrimaryList(1);
        this.getAreaList();
    },
};
</script>
